import axios from '@/config/axios';
import { IRestaurant } from '@/views/OrdersTableView/types';
import apiEndpoints from './const';
import { ApplicationEnum, IResponse, ITutorial } from './types';
import { parseTutorial } from './transformer';

export default class TutorialAPIManager {
    static #instance: TutorialAPIManager;

    public static getInstance() {
        if (!this.#instance) {
            this.#instance = new TutorialAPIManager();
        }

        return this.#instance;
    }

    private readonly corsProxy = 'http://localhost:8080/';

    public getTutorial(app: ApplicationEnum, cc: string, vendor?: IRestaurant) {
        return Promise.allSettled([
            axios.get<IResponse>(`${apiEndpoints.getForCountry.replace(':namespace', app).replace(':cc', cc)}`, {
                'axios-retry': {
                    retries: 3,
                },
            }),
            ...(vendor
                ? [
                      axios.get<IResponse>(
                          `${apiEndpoints.getForRestaurant
                              .replace(':namespace', app)
                              .replace(':cc', cc)
                              .replace(':slug', vendor.restaurant_unique)}`,
                          {
                              'axios-retry': {
                                  retries: 3,
                              },
                          },
                      ),
                  ]
                : []),
        ])
            .then((res) => {
                return res.reduce<ITutorial[]>((acc, item) => {
                    if (item.status === 'fulfilled') {
                        acc.push(...(item.value.data as IResponse).tutorials);
                    } else if (item.status === 'rejected') {
                        console.warn('Error(tutorial-api-manager): ', item.reason);
                    }
                    return acc;
                }, []);
            })
            .then((items) => {
                return items.map((item) => parseTutorial(item));
            });
    }
}
